import { render, staticRenderFns } from "./AboutHeading.vue?vue&type=template&id=6a643829&"
import script from "./AboutHeading.vue?vue&type=script&lang=js&"
export * from "./AboutHeading.vue?vue&type=script&lang=js&"
import style0 from "./AboutHeading.vue?vue&type=style&index=0&id=6a643829&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports